export default __webpack_public_path__ + "static/media/422.dae55c74.gif";